<template>
  <v-dialog :value="value" max-width="980" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="text-h6">
        Cambio de máquina
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <strong>Clave ODT:</strong> {{ item.clave || "-" }}
          </v-col>
          <v-col v-if="gamemode" cols="12" md="4">
            <strong>ID Trabajo Orden:</strong> {{ item.idTrabajoOrden || "-" }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="5">
            <p class="mb-2 font-weight-bold">Articulos de la ODT</p>
            <div class="d-flex flex-wrap" style="gap: 8px;">
              <v-chip v-for="(articulo, idx) in articulosConRepeticiones" :key="`odt-art-${idx}`" small color="primary"
                text-color="white">
                {{ articulo }}
              </v-chip>
              <span v-if="!articulosConRepeticiones.length">Sin articulos</span>
            </div>
          </v-col>

          <v-col cols="12" md="7">
            <v-autocomplete v-model="idMaquinaSeleccionada" :items="maquinasOpcionesSelector" item-value="idMaquina"
              :item-text="nombreMaquinaOpcion" item-disabled="disabled"
              :disabled="loadingMoldes || loadingMaquinas || !maquinasOpcionesSelector.length"
              :loading="loadingMoldes || loadingMaquinas"
              label="Maquinas disponibles (molde compatible + tokens por instancia)" clearable dense hide-details="auto" />
            <p class="mt-2 mb-0 caption" v-if="!loadingMoldes && !loadingMaquinas && !maquinasElegibles.length">
              No hay máquinas habilitadas: deben cumplir molde compatible y al menos una instancia con tokens suficientes.
            </p>
          </v-col>
        </v-row>
        <v-row v-if="moldeSeleccionado">
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="py-2">Molde seleccionado</v-card-title>
              <v-card-text class="py-2">
                <div><strong>Codigo:</strong> {{ moldeSeleccionado.codigo || "-" }}</div>
                <div><strong>Máquina:</strong> {{ moldeSeleccionado.maquinaNombre || "-" }}</div>
                <div><strong>Articulos:</strong> {{ (moldeSeleccionado.articulos || []).join(", ") || "-" }}</div>
                <v-divider class="my-2" />
                <div class="mb-1"><strong>Cavidades:</strong></div>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">#</th>
                        <th class="text-left">Clave</th>
                        <th class="text-left">Artículo</th>
                        <th class="text-left">Activo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(cavidad, idx) in cavidadesMoldeSeleccionado" :key="`cav-${cavidad.idMoldeCavidad || idx}`">
                        <td>{{ idx + 1 }}</td>
                        <td>{{ cavidad.clave || "-" }}</td>
                        <td>{{ cavidad.nombre || "-" }}</td>
                        <td>
                          <v-chip x-small :color="cavidad.activo ? 'success' : 'grey'" text-color="white">
                            {{ cavidad.activo ? "Si" : "No" }}
                          </v-chip>
                        </td>
                      </tr>
                      <tr v-if="!cavidadesMoldeSeleccionado.length">
                        <td colspan="5" class="text-center">Sin cavidades registradas</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <div v-if="gamemode">
          <p class="mb-2 font-weight-bold">Moldes del EP</p>
          <v-row>
            <v-col cols="12" md="5">
              <v-autocomplete v-model="filtroMaquinaId" :items="maquinasFiltroTabla" item-value="idMaquina"
                :item-text="nombreMaquinaFiltro" label="Filtro de maquina" clearable dense hide-details="auto"
                :disabled="loadingMoldes" />
            </v-col>
            <v-col cols="12" md="5">
              <v-autocomplete v-model="filtroMoldeCodigo" :items="moldesFiltroTabla" item-value="codigo"
                item-text="codigo" label="Filtro de molde" clearable dense hide-details="auto"
                :disabled="loadingMoldes" />
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center justify-end">
              <v-btn color="primary" small :loading="loadingMoldes" :disabled="loadingMoldes" @click="getMoldes">
                <v-icon left small>mdi-refresh</v-icon>
                Recargar
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table :headers="moldesHeaders" :items="moldesNormalizadosFiltrados" :loading="loadingMoldes" dense
            :items-per-page="8">
            <template v-slot:[`item.articulos`]="{ item: molde }">
              <span>{{ molde.articulos.join(", ") || "-" }}</span>
            </template>
            <template v-slot:[`item.cubreCompleto`]="{ item: molde }">
              <v-chip x-small :color="molde.cubreCompleto ? 'success' : 'grey'" text-color="white">
                {{ molde.cubreCompleto ? "Si" : "No" }}
              </v-chip>
            </template>
          </v-data-table>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="red" text :loading="updating" :disabled="!puedeActualizar || updating" @click="actualizarRecetasPorMolde">
          Actualizar
        </v-btn>
        <v-btn color="primary" text @click="$emit('input', false)">
          Cerrar
        </v-btn>
      </v-card-actions>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="6000" top>
        {{ snackbar.text }}
        <v-btn text @click="snackbar.show = false">Cerrar</v-btn>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "CambioMaquinaDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      moldes: [],
      maquinasIns: [],
      loadingMoldes: false,
      loadingMaquinas: false,
      updating: false,
      idMaquinaSeleccionada: null,
      filtroMaquinaId: null,
      filtroMoldeCodigo: null,
      snackbar: { show: false, color: "success", text: "" },
      moldesHeaders: [
        { text: "Codigo", value: "codigo", align: "center" },
        { text: "Maquina", value: "maquinaNombre", align: "center" },
        { text: "Articulos", value: "articulos", align: "center" },
        { text: "Cubre ODT", value: "cubreCompleto", align: "center" },
      ],
    };
  },
  computed: {
    articulosODT() {
      const detalles = Array.isArray(this.item && this.item.articulos) ? this.item.articulos : [];
      return detalles
        .map((detalle) => {
          const idArticulo = detalle && detalle.idArticulo !== undefined ? detalle.idArticulo : null;
          const nombre = (detalle && (detalle.nombre || detalle.articulo)) ? String(detalle.nombre || detalle.articulo).trim() : "";
          const codigo = (detalle && (detalle.clave || detalle.codigo)) ? String(detalle.clave || detalle.codigo).trim() : "";
          return {
            key: idArticulo !== null ? `id-${idArticulo}` : `nom-${nombre.toLowerCase()}`,
            nombre: nombre || (idArticulo !== null ? `Articulo ${idArticulo}` : "Articulo"),
            codigo,
          };
        })
        .filter((art) => art.key !== "nom-");
    },
    articulosConRepeticiones() {
      const mapa = new Map();
      this.articulosODT.forEach((art) => {
        const prev = mapa.get(art.key);
        if (prev) {
          prev.count += 1;
        } else {
          mapa.set(art.key, { nombre: art.nombre, codigo: art.codigo, count: 1 });
        }
      });
      return Array.from(mapa.values()).map((art) => `${art.codigo ? `${art.codigo} - ` : ""}${art.nombre} X${art.count}`);
    },
    contadorArticulosODT() {
      const mapa = new Map();
      this.articulosODT.forEach((art) => {
        mapa.set(art.key, (mapa.get(art.key) || 0) + 1);
      });
      return mapa;
    },
    tokensRequeridosODT() {
      let total = 0;
      this.contadorArticulosODT.forEach((cantidad) => {
        total += Number(cantidad) || 0;
      });
      return total;
    },
    moldesNormalizados() {
      return (Array.isArray(this.moldes) ? this.moldes : []).map((molde) => {
        const cavidades = Array.isArray(molde.cavidades) ? molde.cavidades : [];
        const cavidadesActivas = cavidades.filter((cav) => !!(cav && cav.activo));
        const articulos = cavidades
          .map((cav) => {
            const nombre = (cav && (cav.articulo || cav.nombre)) ? String(cav.articulo || cav.nombre).trim() : "";
            return nombre;
          })
          .filter((x) => !!x);

        const contadorActivasMolde = new Map();
        cavidadesActivas.forEach((cav) => {
          const idArticulo = cav && cav.idArticulo !== undefined ? cav.idArticulo : null;
          const nombre = (cav && (cav.articulo || cav.nombre)) ? String(cav.articulo || cav.nombre).trim() : "";
          const llave = idArticulo !== null ? `id-${idArticulo}` : `nom-${nombre.toLowerCase()}`;
          contadorActivasMolde.set(llave, (contadorActivasMolde.get(llave) || 0) + 1);
        });

        const cubreCompleto = this.cubreArticulosODT(contadorActivasMolde);

        return {
          idMolde: molde && molde.idMolde !== undefined ? molde.idMolde : null,
          codigo: molde.codigo || "-",
          idMaquina: molde && molde.idMaquina !== undefined && molde.idMaquina !== null ? molde.idMaquina : null,
          maquinaNombre: molde.maquina || (molde && molde.idMaquina !== undefined && molde.idMaquina !== null ? `Maquina ${molde.idMaquina}` : "-"),
          articulos: [...new Set(articulos)],
          cavidades: cavidades,
          cubreCompleto,
        };
      });
    },
    maquinasConMoldeExacto() {
      const mapa = new Map();
      this.moldesNormalizados
        .filter((molde) => molde.cubreCompleto && molde.idMaquina !== null)
        .forEach((molde) => {
          if (!mapa.has(molde.idMaquina)) {
            mapa.set(molde.idMaquina, {
              idMaquina: molde.idMaquina,
              nombre: molde.maquinaNombre,
            });
          }
        });
      return Array.from(mapa.values()).sort((a, b) => String(a.nombre).localeCompare(String(b.nombre)));
    },
    maquinasTodas() {
      const mapa = new Map();
      (Array.isArray(this.maquinasIns) ? this.maquinasIns : []).forEach((inst) => {
        const idMaquina = inst && inst.idMaquina !== undefined && inst.idMaquina !== null ? inst.idMaquina : null;
        if (idMaquina === null) return;
        if (!mapa.has(idMaquina)) {
          mapa.set(idMaquina, {
            idMaquina,
            nombre: inst.nombre || "",
            marca: inst.marca || (inst.maquina && inst.maquina.marca) || "",
            modelo: inst.modelo || (inst.maquina && inst.maquina.modelo) || "",
            instancias: [],
          });
        }
        mapa.get(idMaquina).instancias.push(inst);
      });
      return Array.from(mapa.values()).sort((a, b) => {
        const na = `${a.nombre} ${a.marca} ${a.modelo}`.trim().toLowerCase();
        const nb = `${b.nombre} ${b.marca} ${b.modelo}`.trim().toLowerCase();
        return na.localeCompare(nb);
      });
    },
    maquinasElegibles() {
      return this.maquinasOpcionesSelector.filter((m) => !m.disabled);
    },
    moldesExactosMaquinaSeleccionada() {
      if (this.idMaquinaSeleccionada == null) return [];
      return this.moldesNormalizados.filter(
        (molde) => molde.idMaquina === this.idMaquinaSeleccionada && molde.cubreCompleto
      );
    },
    moldeSeleccionado() {
      if (!this.moldesExactosMaquinaSeleccionada.length) return null;
      return this.moldesExactosMaquinaSeleccionada[0];
    },
    cavidadesMoldeSeleccionado() {
      if (!this.moldeSeleccionado || !Array.isArray(this.moldeSeleccionado.cavidades)) return [];
      return [...this.moldeSeleccionado.cavidades].sort((a, b) => {
        const av = a && a.activo ? 1 : 0;
        const bv = b && b.activo ? 1 : 0;
        return bv - av;
      });
    },
    maquinasOpcionesSelector() {
      const idsConMoldeExacto = new Set(this.maquinasConMoldeExacto.map((m) => m.idMaquina));
      const tokensRequeridos = this.tokensRequeridosODT;

      return this.maquinasTodas.map((maquina) => {
        const cumpleMolde = idsConMoldeExacto.has(maquina.idMaquina);
        const cumpleTokens = maquina.instancias.some((instancia) => this.tokensActivosInstancia(instancia) >= tokensRequeridos);

        let razon = "";
        if (!cumpleMolde && !cumpleTokens) razon = "Sin molde compatible y sin tokens suficientes";
        else if (!cumpleMolde) razon = "Sin molde compatible";
        else if (!cumpleTokens) razon = `Sin instancia con al menos ${tokensRequeridos} token(es)`;

        return {
          idMaquina: maquina.idMaquina,
          nombre: maquina.nombre,
          marca: maquina.marca,
          modelo: maquina.modelo,
          disabled: !(cumpleMolde && cumpleTokens),
          razon,
        };
      });
    },
    maquinasFiltroTabla() {
      return this.maquinasTodas.map((m) => ({
        idMaquina: m.idMaquina,
        nombre: m.nombre,
        marca: m.marca,
        modelo: m.modelo,
      }));
    },
    moldesFiltroTabla() {
      const mapa = new Map();
      this.moldesNormalizados.forEach((molde) => {
        if (!molde.codigo || molde.codigo === "-") return;
        if (!mapa.has(molde.codigo)) {
          mapa.set(molde.codigo, { codigo: molde.codigo });
        }
      });
      return Array.from(mapa.values()).sort((a, b) => String(a.codigo).localeCompare(String(b.codigo)));
    },
    moldesNormalizadosFiltrados() {
      return this.moldesNormalizados.filter((molde) => {
        const cumpleMaquina = this.filtroMaquinaId == null || molde.idMaquina === this.filtroMaquinaId;
        const cumpleMolde = !this.filtroMoldeCodigo || molde.codigo === this.filtroMoldeCodigo;
        return cumpleMaquina && cumpleMolde;
      });
    },
    puedeActualizar() {
      return !!(
        this.item &&
        this.item.idTrabajoOrden &&
        this.moldeSeleccionado &&
        this.moldeSeleccionado.idMolde
      );
    },
    gamemode() {
      return localStorage.getItem("gamemode") === "true";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        } else {
          this.idMaquinaSeleccionada = null;
        }
      },
    },
    item: {
      deep: true,
      handler() {
        this.idMaquinaSeleccionada = null;
      },
    },
  },
  methods: {
    init() {
      this.getMoldes();
      this.getMaquinasIns();
    },
    nombreMaquinaFiltro(maquina) {
      if (!maquina) return "";
      const nombre = maquina.nombre || "";
      const marca = maquina.marca || "";
      const modelo = maquina.modelo || "";
      const label = `[${nombre}] - ${marca} ${modelo}`.trim();
      return label !== "[] -" ? label : `Maquina ${maquina.idMaquina}`;
    },
    nombreMaquinaOpcion(maquina) {
      if (!maquina) return "";
      const base = this.nombreMaquinaFiltro(maquina);
      return maquina.disabled ? `${base} (No disponible: ${maquina.razon})` : base;
    },
    getMoldes() {
      this.loadingMoldes = true;
      axios
        .get("/Moldes")
        .then((response) => {
          this.moldes = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          console.log(error);
          this.moldes = [];
        })
        .finally(() => {
          this.loadingMoldes = false;
        });
    },
    getMaquinasIns() {
      this.loadingMaquinas = true;
      axios
        .get("/MaquinaInstancias")
        .then((response) => {
          this.maquinasIns = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.maquinasIns = [];
          console.log(error);
        })
        .finally(() => {
          this.loadingMaquinas = false;
        });
    },
    tokensActivosInstancia(instancia) {
      const tokens =
        (Array.isArray(instancia && instancia.tokensExtras) ? instancia.tokensExtras : []).length > 0
          ? instancia.tokensExtras
          : (Array.isArray(instancia && instancia.tokenExtra) ? instancia.tokenExtra : []);

      return tokens.filter((token) => {
        const activo = token && token.activo !== false;
        const condicion = token && token.condicion !== false;
        const tipoValido = token && (token.tipo === undefined || token.tipo === null || Number(token.tipo) === 1);
        return activo && condicion && tipoValido;
      }).length;
    },
    async actualizarRecetasPorMolde() {
      if (!this.puedeActualizar || this.updating) return;
      this.updating = true;
      try {
        const idTrabajoOrden = this.item.idTrabajoOrden;
        const idMolde = this.moldeSeleccionado.idMolde;
        await axios.put(`/TrabajoOrdenes/CambiarRecetasInicialesOTPorMolde/${idTrabajoOrden}/${idMolde}`);
        this.mostrarSnackbar("success", "Cambio de máquina aplicado correctamente.");
        this.$emit("updated", { idTrabajoOrden, idMolde });
        this.$emit("input", false);
      } catch (error) {
        console.log(error);
        this.mostrarSnackbar("error", this.mensajeError(error));
      } finally {
        this.updating = false;
      }
    },
    // Extrae el mensaje del backend (MXResultError: { Code, Msg }) o arma uno por código HTTP.
    mensajeError(error) {
      const resp = error && error.response;
      const data = resp && resp.data;
      const msg = data && (data.Msg || data.msg || data.Message || data.message);
      if (msg) return msg;
      const status = resp && resp.status;
      if (status === 409) {
        return "No se pudo cambiar de máquina: la máquina destino no tiene un token disponible en la misma posición, o la ODT ya tiene producción real.";
      }
      if (status === 404) return "No se encontró la ODT o el molde seleccionado.";
      if (status === 400) return "Datos inválidos para el cambio de máquina.";
      return "No se pudo aplicar el cambio de máquina.";
    },
    mostrarSnackbar(color, text) {
      this.snackbar = { show: true, color, text };
    },
    cubreArticulosODT(contadorActivasMolde) {
      const contadorODT = this.contadorArticulosODT;
      if (!contadorODT.size) return false;

      for (const [llave, cantidadODT] of contadorODT.entries()) {
        if ((contadorActivasMolde.get(llave) || 0) < cantidadODT) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
